module.exports = __webpack_public_path__ + "img/elianaxmas.dd1bec2f.png";